// extracted by mini-css-extract-plugin
export default {"header":"UpdatedHeader_header__uCl-J","onboardingHeader":"UpdatedHeader_onboardingHeader__AtB-J"};